import { render } from "./MetodoPagoPse.vue?vue&type=template&id=4562a5b2"
import script from "./MetodoPagoPse.vue?vue&type=script&lang=js"
export * from "./MetodoPagoPse.vue?vue&type=script&lang=js"

import "./MetodoPagoPse.vue?vue&type=style&index=0&id=4562a5b2&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__